import Accordion from "react-bootstrap/Accordion";
import { Link } from "react-router-dom";
import Breadcrumb from "../Component/Breadcrumb";
import Footer from "../Component/Footer";
import Header from "../Component/Header";
import Menu from "../Component/Menu";
import PageTitle from "../Component/PageTitle";
import LazyLoad from "react-lazyload";
import { Modal, Button } from "react-bootstrap";
import { useState } from "react";

const DigitalDreams = () => {
  const homeMenu = [
    { label: "Awards & Achievements", link: "/awardsAcheivements" },
    {
      label: "Gallery",
      link: "/Gallery",
      subMenu: [
        { label: "Photo Gallery", link: "/Gallery" },
        { label: "Video Gallery", link: "/VideoGallery" },
      ],
    },
    {
      label: "Careers",
      link: "/careers-openings",
      subMenu: [{ label: "Philosophy", link: "/philosophy" }],
    },
    { label: "School Calendar", link: "/calender" },
    {
      label: "Alumni",
      link: "",
      subMenu: [
        { label: "Admissions", link: "/admission" },
        { label: "Admissions IIT", link: "/admissionIIT" },
      ],
    },
    { label: "eMagazine", link: "/Magazine" },
    {
      label: "TAABIR Digital Dreams",
      link: "/digitaldreams",
    },
    {
      label: "CUET",
      link: "https://webapi.entab.info/api/image/LVISGURGAON/public/pdf/CUET.pdf",
    },
  ];
  const [showModal, setShowModal] = useState(false);
  const [selectedMagazine, setSelectedMagazine] = useState({
    title: "",
    url: "",
  });

  const handleOpenModal = (title, url) => {
    setSelectedMagazine({ title, url });
    setShowModal(true);
  };

  const handleCloseModal = () => setShowModal(false);
  return (
    <>
      <Header />
      <Breadcrumb breadImage="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/apply.jpg" />
      <Menu MenuItem={homeMenu} />
      <div className="padding-blk inner-page">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <PageTitle
                pageTitle="Magazine"
                breadEnd="Magazine"
                breadMid="Magazine"
              />
            </div>
            <div className="col-md-12">
              <Accordion defaultActiveKey="0">
                <Accordion.Item eventKey="0">
                  <Accordion.Header>
                    TAABIR Digital Dreams_Edition 2
                  </Accordion.Header>
                  <Accordion.Body>
                    <div className="d-flex">
                      <div
                        className="magazine"
                        onClick={() =>
                          handleOpenModal(
                            "TAABIR Digital Dreams",
                            "https://online.anyflip.com/wglve/yfeo/mobile/index.html",
                          )
                        }
                      >
                        <LazyLoad height={250} once>
                          <img
                            src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/tabbir_digital_2.png"
                            alt="Lotus Valley School, Gurgaon"
                            className="img-fluid"
                          />
                        </LazyLoad>
                        <p className="fw-bold mt-2">TAABIR Digital Dreams</p>
                      </div>
                    </div>

                    {/* Description text */}
                    <div className="mt-4">
                      <p>
                        <strong>TAABIR:</strong> Where thoughts take shape and
                        dreams find language.
                      </p>

                      <p>
                        Born of imagination and shaped by vision, TAABIR is a
                        student-driven initiative by the Editorial Team of Lotus
                        Valley International School, Gurugram, under the
                        mentorship of our Honourable Director Principal, Mrs.
                        Anita Malhotra.
                      </p>

                      <p>
                        Independent of the annual magazine, TAABIR captures the
                        spontaneous, reflective and original voice of our
                        students. Every step, from concept to creation, is
                        driven by learners. TAABIR does not record events; it
                        reflects emotions, ideas and the inner life of young
                        minds.
                      </p>

                      <p>
                        We are delighted to present <strong>Edition 2</strong>,
                        which delves into the theme of{" "}
                        <strong>Perception</strong>.
                      </p>

                      <p>May these pages speak to you!</p>

                      <p className="mt-3 fw-semibold">Editorial Team_LVISG</p>
                    </div>
                  </Accordion.Body>
                </Accordion.Item>

                <Accordion.Item eventKey="1">
                  <Accordion.Header>TAABIR Digital Dreams</Accordion.Header>
                  <Accordion.Body>
                    <div className="d-flex">
                      <div
                        className="magazine"
                        onClick={() =>
                          handleOpenModal(
                            "TAABIR Digital Dreams",
                            "https://online.anyflip.com/wrkqw/xpqh/mobile/index.html",
                          )
                        }
                      >
                        <LazyLoad>
                          <img
                            src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/tabbir_digital_1.JPG"
                            alt="Lotus Valley School, Gurgaon"
                            className="img-fluid"
                          />
                        </LazyLoad>
                        <p>TAABIR Digital Dreams</p>
                      </div>
                    </div>
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
            </div>
          </div>
        </div>
      </div>
      <Modal show={showModal} onHide={handleCloseModal} size="xl" centered>
        <Modal.Header closeButton>
          <Modal.Title>{selectedMagazine.title}</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ height: "80vh" }}>
          <iframe
            src={selectedMagazine.url}
            width="100%"
            height="100%"
            style={{ border: "none" }}
            title={selectedMagazine.title}
          ></iframe>
        </Modal.Body>
      </Modal>

      <Footer />
    </>
  );
};
export default DigitalDreams;
